var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('incidentReports.workResumed'),"data-cy":"backToWork"},model:{value:(_vm.value.backToWork),callback:function ($$v) {_vm.$set(_vm.value, "backToWork", $$v)},expression:"value.backToWork"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }